module.exports = __webpack_public_path__ + "img/c08_buildingtechashokaswrath_Normal_ua.a7e11425.webp";